// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_SST","cls2":"UpsellModalRedesign-cls2_IcJ UpsellModalRedesign-cls1_SST"};